import React, {useState, useEffect, useRef} from "react";
import OwlCarousel from 'react-owl-carousel2';
import PortableText from "./portableText";
import StepSlide from "./stepSlide";
import * as styles from './stepSlider.module.css';
import { gsap, TweenMax, Expo } from "gsap";

let owlClass = "step-owl " + styles.sliderWrap;

function StepSlider(props) {

    let options = {
        items: 1,
        nav: false,
        dots: true,
        autoplay: false,
        margin: 10,
        loop: false,
        freeDrag : false,
        smartSpeed : 600,
        responsive : {
            0 : {
                items: 1
            },
            900 : {
                mouseDrag: false,
                pullDrag: false
            }
        }
    };

    if(props.slides.length > 1){
        options = {
            items: 1,
            nav: false,
            dots: true,
            dotsEach : true,
            autoplay: true,
            autoplayTimeout: 7000,
            autoplaySpeed : 600,
            margin: 10,
            loop: true,
            freeDrag : true,
            smartSpeed : 600,
            autoplaySpeed : 600,
            responsive : {
                0 : {
                    items: 1
                }
            }
        };
    }
    
    let owlId = "step-owl-"+props.uniqueSlug;

    const sectionRef = useRef();
    const owlRef = useRef();
    const mobileRef = useRef();
    

    useEffect(() => {

        let isInViewport = (ins, os) => {
            let offset = (os) ? os : 0;
            if(ins.offset()){
                let elementTop = ins.offset().top + 10 - offset;
                let elementBottom = elementTop + ins.outerHeight() - offset;
                let viewportTop = $(window).scrollTop();
                let viewportBottom = viewportTop + $(window).height();
                return elementBottom > viewportTop && elementTop < viewportBottom;
            }
            return false;
        }

        let owl = $('#'+owlId);
        let currentIndex = 0;
        let isBusy = false;

        if(props.slides.length > 1){

            owl.on('changed.owl.carousel', function (e) {

                currentIndex = e.relatedTarget.current()
                let $el = owl.find('.owl-item').eq(currentIndex);

                TweenMax.set([$el.find('.'+styles.siContentWrap+' h5'), $el.find('.'+styles.siContentWrap+' h3'), $el.find('.'+styles.siContentWrap+' p')], {
                    x : 80,
                    opacity : 0
                });

                TweenMax.to($el.find('.'+styles.siContentWrap+' h5'), 0.45, {
                    x : 0,
                    opacity : 1,
                    delay: 0.25
                });
                TweenMax.to($el.find('.'+styles.siContentWrap+' h3'), 0.45, {
                    x : 0,
                    opacity : 1,
                    delay: 0.5
                });
                TweenMax.to($el.find('.'+styles.siContentWrap+' p'), 0.45, {
                    x : 0,
                    opacity : 1,
                    delay: 0.75
                });
            })
            
            // owl.on('mousewheel', '.owl-stage', function (e) {

            //     if(currentIndex < (props.slides.length - 1) && currentIndex > 0){
            //         e.preventDefault();
            //     }

            //     if(!isBusy){
            //         isBusy = true;
            //         if (e.originalEvent.deltaY>0) {
            //             let next = currentIndex+1;
            //             if(next <= (props.slides.length - 1)){
            //                 owl.find('.owl-dot').eq(next).click();
            //                 e.preventDefault();
            //             }
            //         } else {
            //             let prev = currentIndex-1;
            //             if(prev >= 0){
            //                 owl.find('.owl-dot').eq(prev).click();
            //                 e.preventDefault();
            //             }
            //         }
            //         setTimeout(() => {
            //             isBusy = false;
            //         }, 700);
            //     } else {
            //         e.preventDefault();
            //     }
                
            // });
        } 
        

        // TweenMax.set([$('.'+styles.siContentWrap+' h5'), $('.'+styles.siContentWrap+' h3'), $('.'+styles.siContentWrap+' p'), $(mobileRef.current)], {
        //     x : 80,
        //     opacity : 0
        // });

        if(!$(sectionRef.current).hasClass('anim-complete')){
            $(window).on('scroll', () => {
                if(isInViewport($(sectionRef.current), (0-($(window).height()/4)) )){
                    let $el = owl.find('.owl-item.active');
                    // TweenMax.to($el.find('.'+styles.siContentWrap+' h5'), 0.45, {
                    //     x : 0,
                    //     opacity : 1,
                    //     delay: 0.25
                    // });
                    // TweenMax.to($el.find('.'+styles.siContentWrap+' h3'), 0.45, {
                    //     x : 0,
                    //     opacity : 1,
                    //     delay: 0.5
                    // });
                    // TweenMax.to($(mobileRef.current), 0.45, {
                    //     x : 0,
                    //     opacity : 1,
                    //     delay: 0.5
                    // });
                    // TweenMax.to($el.find('.'+styles.siContentWrap+' p'), 0.45, {
                    //     x : 0,
                    //     opacity : 1,
                    //     delay: 0.75,
                    //     onComplete : () => {
                    //         $(sectionRef.current).addClass('anim-complete');
                    //     }
                    // });
                    $(sectionRef.current).addClass('anim-complete');
                    owl.trigger('play.owl.autoplay', [1000]);
                }
            });
        }

    }, []);

    return (
        <div className={styles.sectionStepSlider} ref={sectionRef}>
            <div className={styles.sectionContent}>
                <div className={styles.sectionContainer}>
                    <h3 className={styles.sectionHeading}>{props.label}</h3>
                    <div className={owlClass} id={owlId} ref={owlRef}>

                        <OwlCarousel options={options}>

                            {
                                props.slides.map((item, i) => {  
                                    return <StepSlide item={item} key={i} />
                                })
                            }

                        </OwlCarousel>

                    </div>
                    <div className={styles.mobileSlides} ref={mobileRef}>

                        {
                            props.slides.map((item, i) => {  
                                return (
                                    <div className={styles.mobileSlideItem} key={i}>
                                        <div className={styles.msiImageWrap}>
                                            {
                                                (item.image) ?
                                                <img src={item.image.image.asset.url} alt={item.title} />
                                                : ``
                                            }
                                        </div>
                                        <div className={styles.msiContentWrap}>
                                            <h3>{item.heading}</h3>
                                            <PortableText blocks={item.desc} />
                                        </div>
                                    </div>
                                );
                            })
                        }

                    </div>
                </div>
            </div>
        </div>
    );
}
  
export default StepSlider;